import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-2 max-h-60" }
const _hoisted_2 = {
  key: 0,
  class: "text-primary text-xs whitespace-nowrap me-2 align-middle"
}
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "flex flex-col min-h-full" }
const _hoisted_5 = { class: "flex-grow" }
const _hoisted_6 = {
  href: "https://shop.geo.de/de_DE/geocard-rabatt.html?onwewe=08105&utm_source=&utm_medium=shop-teaser&utm_campaign=geo-div-geocardrabatt_20%25imshop-non",
  target: "_blank",
  rel: "noopener"
}
const _hoisted_7 = { class: "geocard-block" }
const _hoisted_8 = {
  key: 0,
  class: "relative w-[350px] h-[220px] bg-no-repeat bg-cover text-black rounded-xl overflow-hidden",
  style: {"background-image":"url('/img/geocard.svg')"}
}
const _hoisted_9 = { class: "absolute top-6 right-6 mt-[5.2rem] me-2 text-right" }
const _hoisted_10 = { class: "text-xl font-bold" }
const _hoisted_11 = { class: "text-xs" }
const _hoisted_12 = { class: "absolute bottom-6 left-6 ml-3 text-left" }
const _hoisted_13 = { class: "text-base" }
const _hoisted_14 = {
  key: 1,
  class: "relative w-full p-2 text-center"
}
const _hoisted_15 = {
  key: 2,
  class: "relative w-full p-2 text-center"
}

import { computed, onMounted, onBeforeUnmount, ref } from "vue";
import {
  IonApp,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonButton,
  IonIcon,
  IonList,
  IonItem,
  IonPopover,
  IonLabel,
  IonBadge,
  IonActionSheet,
  IonFooter,
  IonModal,
  IonListHeader,
  IonToast,
} from "@ionic/vue";
import { useAuth } from "@/services/auth";
import { notificationsSharp, personSharp, imagesSharp, homeSharp, cartSharp, locationSharp } from "ionicons/icons";
import { newVersionAvailable } from "@/registerServiceWorker";
import { useRouter } from "vue-router";
import { useCurrentUser } from "@/composables/useCurrentUser";
import { useMessages } from "@/composables/useMessages";

const REQUIRED_SCHEMA_VERSION = "v2";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { isLoggedIn, logout, checkLoginStatus } = useAuth();
const { currentUser, loadUser } = useCurrentUser();
const { messages, unreadMessages, unreadCount, fetchMessages } = useMessages();

const popoverOpen = ref(false);
const router = useRouter();

function openPopover() {
  popoverOpen.value = true;
}

function closePopover() {
  popoverOpen.value = false;
}

function handleLinkClick(e: MouseEvent) {
  const target = e.target as HTMLElement;
  const a = target.closest("a[href]") as HTMLAnchorElement | null;
  if (!a || !(window as any).umami) return;
  if (a.hasAttribute("data-umami-event")) return;

  const isExternal = a.host !== window.location.host;
  if (!isExternal) return;

  const payload = {
    target: a.href,
    page: window.location.pathname,
  };

  (window as any).umami.track("outbound-link-click", payload);
}

const checkCode = computed(() => {
  const now = new Date();
  const mm = String(now.getMonth() + 1).padStart(2, "0"); // Monat zweistellig
  const jj = String(now.getFullYear()).slice(-2); // Jahr zweistellig

  const userRaw = localStorage.getItem("gcU");
  if (!userRaw) return `${mm}-${jj}-De-Fa`;

  try {
    const user = JSON.parse(userRaw);
    if (!user.firstname || !user.lastname) return `${mm}-${jj}-De-Fa`;

    const vorname = user.firstname.substring(0, 2);
    const nachname = user.lastname.substring(0, 2);

    return `${mm}-${jj}-${vorname}-${nachname}`;
  } catch (e) {
    return `${mm}-${jj}-De-Fa`;
  }
});

const startLogin = async () => {
  window.location.href = process.env.VUE_APP_API_URL + "/api/login-start";
};

onMounted(() => {
  document.addEventListener("click", handleLinkClick);

  const userRaw = localStorage.getItem("gcU");
  if (userRaw) {
    try {
      const user = JSON.parse(userRaw);

      if (user.schemaVersion !== REQUIRED_SCHEMA_VERSION) {
        localStorage.removeItem("gcU");
        localStorage.removeItem("gcU_exp");
        handleLogout();
        return;
      }
    } catch (err) {
      localStorage.removeItem("gcU");
      localStorage.removeItem("gcU_exp");
      handleLogout();
      return;
    }
  }

  checkLoginStatus();
  if (isLoggedIn.value) {
    loadUser();
    fetchMessages();
  }
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleLinkClick);
});

const handleLogout = () => {
  logout();
};

const accountMenuOpen = ref(false);
const accountMenuButtons = computed(() => {
  if (isLoggedIn.value) {
    const buttons = [];

    if (currentUser.value?.subs?.length > 0) {
      buttons.push({
        text: "Benachrichtigungen",
        handler: () => router.push("/account"),
      });
    }

    buttons.push({
      text: "Abmelden",
      role: "destructive",
      handler: () => handleLogout(),
    });

    return buttons;
  } else {
    return [
      {
        text: "Registrierung",
        handler: () => window.open(process.env.VUE_APP_GUJ_REGISTER_URL, "_blank", "noopener,noreferrer"),
      },
      {
        text: "Login",
        handler: () => startLogin(),
      },
    ];
  }
});

const openAccountMenu = () => {
  accountMenuOpen.value = true;
};

const goToMessage = (id: number) => {
  closePopover();
  router.push({ path: "/account", query: { id } });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonPage), { id: "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonHeader), { class: "py-4" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTitle), null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: "/",
                        class: "inline-block max-w-[200px]"
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createElementVNode("img", {
                            src: "/img/logo-main.svg",
                            alt: "GEOcard",
                            class: "h-9"
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonButtons), { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), { onClick: openAccountMenu }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_unref(IonIcon), {
                              icon: _unref(personSharp),
                              color: "primary",
                              style: {"font-size":"24px"}
                            }, null, 8, ["icon"])
                          ])
                        ]),
                        _: 1
                      }),
                      (_unref(isLoggedIn) && _unref(currentUser)?.subs.length > 0)
                        ? (_openBlock(), _createBlock(_unref(IonButton), {
                            key: 0,
                            id: "notification-button",
                            onClick: openPopover
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_unref(IonIcon), {
                                  icon: _unref(notificationsSharp),
                                  color: "primary",
                                  style: {"font-size":"24px"}
                                }, null, 8, ["icon"]),
                                (_unref(unreadCount) > 0)
                                  ? (_openBlock(), _createBlock(_unref(IonBadge), {
                                      key: 0,
                                      color: "danger",
                                      style: {"font-size":"x-small"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(unreadCount)), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(isLoggedIn) && _unref(currentUser)?.subs.length > 0)
                        ? (_openBlock(), _createBlock(_unref(IonPopover), {
                            key: 1,
                            trigger: "notification-button",
                            "is-open": popoverOpen.value,
                            onDidDismiss: closePopover,
                            side: "bottom",
                            alignment: "start",
                            size: "auto"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _createVNode(_unref(IonList), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonListHeader), { lines: "inset" }, {
                                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createElementVNode("h3", null, "Benachrichtigungen", -1)
                                      ])),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (msg) => {
                                      return (_openBlock(), _createBlock(_unref(IonItem), {
                                        key: msg.id,
                                        button: true,
                                        detail: false,
                                        onClick: ($event: any) => (goToMessage(msg.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonLabel), { class: "flex justify-between items-center w-full" }, {
                                            default: _withCtx(() => [
                                              (_unref(unreadMessages).find((m) => m.id === msg.id))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, " ● "))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("span", _hoisted_3, _toDisplayString(msg.subject), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["is-open"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonContent), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_RouterView)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), { color: "primary" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButtons), { class: "ion-justify-content-center pt-2 pb-3 text-black hover:bg-inherit" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        color: "black",
                        style: {"margin":"0 5px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: "/" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                icon: _unref(homeSharp),
                                style: {"font-size":"28px","fill":"black"}
                              }, null, 8, ["icon"]),
                              _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                              _createVNode(_unref(IonLabel), { style: {"font-size":"x-small","color":"black"} }, {
                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                  _createTextVNode("Start")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonButton), {
                        color: "black",
                        style: {"margin":"0 5px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: "/partner" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                icon: _unref(locationSharp),
                                style: {"font-size":"28px","fill":"black"}
                              }, null, 8, ["icon"]),
                              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                              _createVNode(_unref(IonLabel), { style: {"font-size":"x-small","color":"black"} }, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createTextVNode("Partner")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonButton), {
                        color: "black",
                        id: "open-geocard-modal",
                        style: {"margin":"0 5px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_unref(IonIcon), {
                              src: "/img/icons/geocard-icon.svg",
                              style: {"font-size":"28px","fill":"black"}
                            }),
                            _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                            _createVNode(_unref(IonLabel), { style: {"font-size":"x-small","text-transform":"none","color":"black"} }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("GEOcard")
                              ])),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonButton), {
                        color: "black",
                        style: {"margin":"0 5px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_6, [
                            _createVNode(_unref(IonIcon), {
                              icon: _unref(cartSharp),
                              style: {"font-size":"28px","fill":"black"}
                            }, null, 8, ["icon"]),
                            _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                            _createVNode(_unref(IonLabel), { style: {"font-size":"x-small","color":"black"} }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createTextVNode("Shop")
                              ])),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonButton), {
                        color: "black",
                        style: {"margin":"0 5px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, { to: "/downloads" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                icon: _unref(imagesSharp),
                                style: {"font-size":"28px","fill":"black"}
                              }, null, 8, ["icon"]),
                              _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                              _createVNode(_unref(IonLabel), { style: {"font-size":"x-small","color":"black"} }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                  _createTextVNode("Downloads")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonActionSheet), {
            "is-open": accountMenuOpen.value,
            onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (accountMenuOpen.value = false)),
            header: "Mein Account",
            buttons: accountMenuButtons.value,
            mode: "ios"
          }, null, 8, ["is-open", "buttons"]),
          _createVNode(_unref(IonToast), {
            "is-open": _unref(newVersionAvailable),
            message: "Neue App Version wird geladen...",
            position: "top",
            "position-anchor": "header"
          }, null, 8, ["is-open"]),
          _createVNode(_unref(IonModal), {
            trigger: "open-geocard-modal",
            "initial-breakpoint": 1,
            breakpoints: [0, 1]
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                (_unref(isLoggedIn) && _unref(currentUser)?.subs && _unref(currentUser)?.subs.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", _hoisted_10, _toDisplayString(new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })), 1),
                        _createElementVNode("p", _hoisted_11, "Prüf-Code: " + _toDisplayString(checkCode.value), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(currentUser)?.name), 1)
                      ])
                    ]))
                  : (_unref(currentUser)?.subs.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Sie haben derzeit kein aktives Abo, um eine persönliche GEOcard anzuzeigen. "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, " Bitte einloggen, um die persönliche GEOcard anzuzeigen. "))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})